var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { IconWithLabel } from 'modules/IconWithLabel';
import { Falcon } from 'modules/macro';
import { Label, InputOverlay, HiddenInput } from './styled';
const sizeMap = {
    medium: 'lg',
    small: 'md',
};
/**
 * This component is internal only, it's used so CheckCard and RadioCard can share logic
 */
export function ToggleCard(props) {
    const { invalid = false, title, type, subtitle, icon, alignment, size = 'medium' } = props, restProps = __rest(props, ["invalid", "title", "type", "subtitle", "icon", "alignment", "size"]);
    return (<Label $invalid={invalid} $alignment={alignment} $size={size}>
      <IconWithLabel truncate={false} size={sizeMap[size]} title={title} subtitle={subtitle} alignment={alignment}>
        {icon}
      </IconWithLabel>
      <HiddenInput type={type} {...restProps}/>
      <InputOverlay $type={type} $invalid={invalid} $alignment={alignment}>
        <Falcon icon="check" $size={12} $color="gray.0"/>
      </InputOverlay>
    </Label>);
}
